import { useState } from "react";
import { Nav } from "react-bootstrap";
import { useNavigate } from "react-router-dom";
import { ArrowLeftOutlined } from "@ant-design/icons";
import VaccineReports from "./VaccineReports";
import InClinicAccounting from "./InClinicAccounting";
import VCAccounting from "./VCAccounting";
import PendingVC from "./PendingVC";

const TABS = [
  { key: "vaccine_reports", label: "Vaccine Reports" },
  { key: "in_clinic_accounting", label: "In Clinic Accounting" },
  { key: "vc_accounting", label: "VC Accounting" },
  { key: "pending_vc", label: "Pending VC" },
];

export default function AccountingTabs() {
  const [activeTab, setActiveTab] = useState("in_clinic_accounting");
  const navigate = useNavigate();

  const handleBackClick = () => {
    navigate("/doctor-dashboard");
  };

  return (
    <div>
      <div
        style={{
          display: "flex",
          alignItems: "center",
          gap: "8px",
          borderBottom: "1px solid #f0f0f0",
        }}
      >
        <span
          onClick={handleBackClick}
          role="button"
          tabIndex={0}
          onKeyDown={(e) => {
            if (e.key === "Enter" || e.key === " ") handleBackClick();
          }}
          style={{
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            width: "36px",
            height: "36px",
            cursor: "pointer",
            color: "#595959",
            fontSize: "18px",
          }}
          aria-label="Back to dashboard"
        >
          <ArrowLeftOutlined />
        </span>

        <Nav
          variant="tabs"
          activeKey={activeTab}
          onSelect={(key) => setActiveTab(key)}
          style={{ border: "none", flex: 1 }}
        >
          {TABS.map((tab) => (
            <Nav.Item key={tab.key}>
              <Nav.Link
                eventKey={tab.key}
                style={{
                  fontWeight: 500,
                  fontSize: "16px",
                  color: activeTab === tab.key ? "#1677ff" : "#595959",
                  border: "none",
                  borderBottom:
                    activeTab === tab.key
                      ? "2px solid #1677ff"
                      : "2px solid transparent",
                  background: "transparent",
                  padding: "12px 20px",
                }}
              >
                {tab.label}
              </Nav.Link>
            </Nav.Item>
          ))}
        </Nav>
      </div>

      <div style={{ paddingTop: "16px" }}>
        {activeTab === "vaccine_reports" && <VaccineReports />}
        {activeTab === "in_clinic_accounting" && <InClinicAccounting />}
        {activeTab === "vc_accounting" && <VCAccounting />}
        {activeTab === "pending_vc" && <PendingVC />}
      </div>
    </div>
  );
}